import { Box, Flex } from '@mantine/core'

import { useQueryGetAllBookingPayments } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type ParameterID } from '@flecto/types'
import { Badge, Modal } from '@flecto/ui'

import { TableBookingPayments } from '../TableBookingPayments/TableBookingPayments'

export type ModalBookingPaymentsProps = {
  bookingId?: ParameterID
}

export function ModalBookingPayments({ bookingId }: ModalBookingPaymentsProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_payments' })

  const { data: payments, isLoading } = useQueryGetAllBookingPayments({
    bookingId,
  })

  return (
    <Modal size='xl'>
      <Modal.Close />
      <Modal.Title>
        <Flex gap='sm' align='center'>
          <Box>{t('modal.title')}</Box>
          <Badge color='gray'>
            {t('modal.badge', {
              count: payments?.length,
            })}
          </Badge>
        </Flex>
      </Modal.Title>
      <Modal.Content>
        <TableBookingPayments
          bookingPayments={payments}
          isLoading={isLoading}
        />
      </Modal.Content>
    </Modal>
  )
}
